<template>
    <div class="home-main">
        <Row :gutter="8" class="margin-top-10 home-row">
            <!-- 第一列 -->
            <Col span="8" class="row-col">
                <Card class="row-col-left">
                    <div style="height: 100%;">
                        <div id="sims" style="width:100%; height:40vh"></div>
                    </div>
                </Card>
                <!-- 终端统计 -->
                <Card class="row-col-left" style="margin-top: 8px;">
                    <div style="height: 100%;">
                        <div id="census" style="width:100%; height:40vh"></div>
                    </div>
                </Card>
            </Col>
            <!-- 第二列 -->
            <Col span="8" class="row-col" style="height: 100%;">
                <template v-if="showglr">
                    <div class="row-col-center-zero">
                        <Row :gutter="8" class="full-y">
                            <Col span="8" class="full-y">
                                <count-number :showLoadingGif="false" color="fault" title="预警故障"
                                              value="10"></count-number>
                            </Col>
                            <Col span="8" class="full-y">
                                <count-number :showLoadingGif="false" color="fault_collection" title="故障采集率"
                                              value="98%"></count-number>
                            </Col>
                            <Col span="8" class="full-y">
                                <count-number :showLoadingGif="false"  color="warn_collection" title="预警采集错误率"
                                              value="<=1%"></count-number>
                            </Col>
                        </Row>
                    </div>
                </template>
                <div class="row-col-center-one" :style="{height:showglr?'calc(12%-8px)':'12%'}">
                    <Row style="height: 100%;" type="flex" :gutter="8" justify="space-between">
                        <Col span="6" class="full-y bg-red status-number">
                            <count-number :showLoadingGif="showLoadingGif" @onRoute="()=>{$router.push({name:'page_device'})}" icon="icon-dianti" color="red" :title="$t('l.all_lift')"
                                          :value="index.count + ''"></count-number>
                        </Col>
                        <Col span="6" class="full-y bg-blue status-number">
                            <count-number :showLoadingGif="showLoadingGif" @onRoute="()=>{$router.push({name:'page_fault'})}" icon="icon-guzhang" color="orange" :title="$t('l.cum_fault')"
                                          :value="index.faultCount + ''"></count-number>
                        </Col>
                        <Col span="6" class="full-y bg-red status-number">
                            <count-number  :showLoadingGif="showLoadingGif" @onRoute="()=>{$router.push({name:'page_device',params:{page:1,search:$t('l.online')}})}" icon="icon-dianti" color="yellow" :title="$t('l.online_lift')"
                                          :value="index.onlineCount + ''"></count-number>
                        </Col>
                        <Col span="6"  class="full-y bg-blue status-number">
                            <count-number @onRoute="()=>{$Message.warning($t('l.remark182'))}" icon="icon-guzhang" color="blue" :title="$t('l.maintenance_lift')"
                                          :value="index.maintainCount + ''"></count-number>
                        </Col>
                    </Row>
                </div>
                <div class="row-col-center-two" :style="{height:showglr?'calc(30% - 8px)':'30%'}">
                    <Card style="height: 100%;">
                        <Row :gutter="8" style="height: 100%">
                            <Col span="12">
                                <div id="new-fault-every-week" style="height: 24vh;width: 100%"></div>
                            </Col>
                            <Col span="12">
                                <div id="new-lift-every-week" style="height: 24vh;width: 100%"></div>
                            </Col>
                        </Row>
                    </Card>
                </div>
                <div class="row-col-center-three" :style="{height:showglr?'calc(47% - 8px)':'calc(58% - 8px)'}">
                    <Card style="width: 100%;height: 100%;">
                        <Row :gutter="8" type="flex" justify="center" style="height: 100%">
                            <Col span="12">
                                <div style="height: 100%">
                                    <Row>
                                        <Col>
                                            <div id="lift-stat-census" style="height: 20vh"></div>
                                        </Col>
                                        <Col>
                                            <div id="lift-fault-census" style="height: 20vh"></div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col span="12">
                                <div style="height: 100%">
                                    <Row>
                                        <Col>
                                            <div id="lift-maintain-census" style="height: 20vh"></div>
                                        </Col>
                                        <Col>
                                            <div id="lift-repair-census" style="height: 20vh"></div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Card>
                </div>
            </Col>
            <!-- 第三列 -->
            <Col span="8" class="row-col">
                <Card style="height: 45%">
                    <!-- 维保统计 -->
                    <div style="height: 100%">
                        <div id="new-maintain" style="width: 100%;height: 35vh;"></div>
                    </div>
                </Card>
                <Card style="height: 55%;margin-top: 8px">
                    <!-- 故障统计 -->
                    <div style="height: 100%">
                        <div id="tree-diagram" style="width: 100%;height: 45vh;"></div>
                    </div>
                </Card>
            </Col>
        </Row>
        <Spin fix v-if="show">
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>{{$t('l.hint46')}}</div>
        </Spin>
    </div>
</template>

<script>
    import CountNumber from "./components/count-number";
    import echarts from "echarts";
    import util from '@/libs/util.js';
    // import liftStatChart from "./components/lift-stat-chart"
    // import liftMaintainChart from "./components/lift-maintain-chart"

    export default {
        name: "home",
        components: {
            CountNumber,
            // liftStatChart,
            // liftMaintainChart,
        },
        data() {
            return {
                simTypeChar:{}, // sim卡类型统计
                chart: {},  // 统计图
                diagram: {}, // 树状图
                newLift: {}, // 每天新增电梯
                newFault: {}, // 每天新增故障
                newMaintain: {}, // 维保统计
                newTerminal: {},  // 新增终端数量
                onlineChart:{},
                faultChart:{},
                maintenanceChart:{},
                repairChart:{},
                hour: 0,
                minute: 0,
                second: 0,
                show:false,
                showLoadingGif:false,
                simCount:{
                    stopCount:0,
                    ExpireCount:0,
                    normalCount:0,
                    oweCount:0,
                }
            };
        },
        computed: {
            simType(){
                return {
                    title: {
                        text: this.$t('l.sim_statistics'),
                        x: 'center'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c} ({d}%)"
                    },
                    color:['rgb(85, 239, 196)','rgb(255, 118, 117)','rgb(223, 230, 233)','rgb(99, 110, 114)'],
                    legend: {
                        orient: 'vertical',
                        left: 'left',
                        data: [
                            {
                                name:this.$t('l.normalCount'),
                            },
                            {
                                name:this.$t('l.oweCount'),
                            },
                            {
                                name:this.$t('l.stopCount'),
                            },
                            {
                                name:this.$t('l.ExpireCount'),
                            },
                        ]
                    },
                    series: [
                        {
                            name: this.$t("l.sim_statistics"),
                            type: 'pie',
                            radius: '55%',
                            center: ['50%', '60%'],
                            data: [
                                {value: this.simCount.normalCount, name: this.$t('l.normalCount')},
                                {value: this.simCount.oweCount, name: this.$t('l.oweCount')},
                                {value: this.simCount.stopCount, name: this.$t('l.stopCount')},
                                {value: this.simCount.ExpireCount, name: this.$t('l.ExpireCount')}
                            ],
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                }
            },
            option() {
                return {
                    title: {
                        text: this.$t('l.terminal_statistics'),
                        x: 'center'
                    },
                    color:['rgb(116, 185, 255)','rgb(48, 51, 107)','rgb(34, 166, 179)','rgb(74, 105, 189)'],
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c} ({d}%)"
                    },
                    legend: {
                        type:'scroll',
                        y:'bottom',
                        left: 'left',
                        data: [this.$t('l.terminal_smart'), this.$t('l.terminal_face'),this.$t('l.terminal_new_wcr'),this.$t('l.terminal_old_wcr'),this.$t('l.terminal_app')]
                    },
                    series: [
                        {
                            name: this.$t('l.terminal_statistics'),
                            type: 'pie',
                            radius: '55%',
                            center: ['50%', '55%'],
                            data: [
                                {value: this.index.t_terminalCount, name: this.$t('l.terminal_smart')},
                                {value: this.index.f_terminalCount, name: this.$t('l.terminal_face')},
                                {value: this.index.wcr_terminalCount, name:this.$t('l.terminal_new_wcr')},
                                {value: this.index.e_terminalCount, name: this.$t('l.terminal_old_wcr')},
                                {value: this.index.u_terminalCount, name: this.$t('l.terminal_app')},
                            ],
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                };
            },
            optionDiagram() {
                return {
                    title: {
                        text: this.$t('l.fault_deal_statistics')
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                            axisTick: {
                                alignWithLabel: true
                            }
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value'
                        }
                    ],
                    series: [
                        {
                            name: this.$t('l.month_number'),
                            type: 'bar',
                            barWidth: '60%',
                            data: this.index.faultMonthData,
                            itemStyle: {
                                normal: {color: "#ff6600"}
                            }
                        }
                    ]
                }
            },
            optionNewFault() {
                return {
                    tooltip: {
                        formatter: "{a} <br/>{b} : {c}"
                    },
                    series: [
                        {
                            name: this.$t('l.fault_num'),
                            type: 'gauge',
                            detail: {formatter: '{value}', offsetCenter: [0, '90%'], fontSize: '18px'},
                            data: [
                                {value: this.index.todayNewFaultCount, name: this.$t('l.today_fault')},
                            ],
                            splitNumber: 5,
                            title: {
                                fontSize: '18px',
                                fontWeight: 'bolder',
                                offsetCenter: [0, '-120%']
                            }
                        }
                    ]
                };
            },
            optionNewLift() {
                return {
                    tooltip: {
                        formatter: "{a} <br/>{b} : {c}"
                    },
                    series: [
                        {
                            name: this.$t('l.today_add_lift'),
                            type: 'gauge',
                            detail: {formatter: '{value}', offsetCenter: [0, '90%'], fontSize: '18px'},
                            data: [
                                {value: this.index.todayNewLiftCount, name: this.$t('l.today_add_lift')},
                            ],
                            splitNumber: 5,
                            title: {
                                fontSize: '18px',
                                fontWeight: 'bolder',
                                offsetCenter: [0, '-120%']
                            }
                        }
                    ]
                }
            },
            optionNewMaintain() {
                return {
                    title: {
                        text: this.$t('l.maintenance_statistics')
                    },
                    color: ['#3398DB'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                            axisTick: {
                                alignWithLabel: true
                            }
                        }
                    ],
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [820, 932, 901, 934, 1290, 1330, 1320, 901, 934, 1290, 1330, 1320],
                        name: this.$t('l.month_number'),
                        type: 'bar',
                        barWidth: '60%',
                        label: {
                            show: true,
                            position: 'top',
                            color: '#1CD8A8',
                            fontSize: '14px',
                            distance: 25,
                            fontWeight: 'bold'
                        },
                        itemStyle: {
                            barBorderRadius: [20, 20, 0, 0],
                            color: new echarts.graphic.LinearGradient(0, 1, 0, 0, ["#2FAEF2", "#1CD8A8"].map((color, offset) => ({
                                color, offset
                            })))
                        }
                    }]
                }
            },
            onlineOption(){
                return{
                    color:["#ddd","#99ff66"],
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b}: {c} ({d}%)"
                    },
                    legend: {
                        orient: 'vertical',
                        x: 'left',
                        data:[this.$t('l.online'),this.$t('l.offline')]
                    },
                    series: [
                        {
                            name:this.$t('l.online_rate'),
                            type:'pie',
                            radius: ['50%', '70%'],
                            avoidLabelOverlap: false,
                            label: {
                                normal: {
                                    show: false,
                                    position: 'center'
                                },
                                emphasis: {
                                    show: true,
                                    textStyle: {
                                        fontSize: '30',
                                        fontWeight: 'bold'
                                    }
                                }
                            },
                            labelLine: {
                                normal: {
                                    show: false
                                }
                            },
                            data:[
                                {value:(this.index.count-this.index.onlineCount), name:this.$t('l.offline')},
                                {value:this.index.onlineCount ,name:this.$t('l.online')},
                            ]
                        }
                    ]
                };
            },
            faultOption(){
                return{
                    color:["#ff6600","#32b0fb"],
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b}: {c} ({d}%)"
                    },
                    legend: {
                        orient: 'vertical',
                        x: 'left',
                        data:[this.$t('l.fault'),this.$t('l.normal')]
                    },
                    series: [
                        {
                            name:this.$t('l.fault_rate'),
                            type:'pie',
                            radius: ['50%', '70%'],
                            avoidLabelOverlap: false,
                            label: {
                                normal: {
                                    show: false,
                                    position: 'center'
                                },
                                emphasis: {
                                    show: true,
                                    textStyle: {
                                        fontSize: '30',
                                        fontWeight: 'bold'
                                    }
                                }
                            },
                            labelLine: {
                                normal: {
                                    show: false
                                }
                            },
                            data:[
                                {value:this.index.faultCount, name:this.$t('l.fault')},
                                {value:(this.index.count-this.index.faultCount) ,name:this.$t('l.normal')},
                            ]
                        }
                    ]
                };
            },
            maintenanceOption(){
                return{
                    color:["#3399ff","#32b0fb"],
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b}: {c} ({d}%)"
                    },
                    legend: {
                        orient: 'vertical',
                        x: 'left',
                        data:[this.$t('l.wait_maintained'),this.$t('l.maintained')]
                    },
                    series: [
                        {
                            name:this.$t('l.device_maintenance'),
                            type:'pie',
                            radius: ['50%', '70%'],
                            avoidLabelOverlap: false,
                            label: {
                                normal: {
                                    show: false,
                                    position: 'center'
                                },
                                emphasis: {
                                    show: true,
                                    textStyle: {
                                        fontSize: '30',
                                        fontWeight: 'bold'
                                    }
                                }
                            },
                            labelLine: {
                                normal: {
                                    show: false
                                }
                            },
                            data:[
                                {value:this.index.maintenanceCount, name:this.$t('l.wait_maintained')},
                                {value:100-this.index.maintenanceCount ,name:this.$t('l.maintained')},
                            ]
                        }
                    ]
                };
            },
            repairOption(){
                return{
                    color:["#efdf13","#32b0fb"],
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b}: {c} ({d}%)"
                    },
                    legend: {
                        orient: 'vertical',
                        x: 'left',
                        data:[this.$t('l.repair'),this.$t('l.finish')]
                    },
                    series: [
                        {
                            name:this.$t('l.device_maintenance'),
                            type:'pie',
                            radius: ['50%', '70%'],
                            avoidLabelOverlap: false,
                            label: {
                                normal: {
                                    show: false,
                                    position: 'center'
                                },
                                emphasis: {
                                    show: true,
                                    textStyle: {
                                        fontSize: '30',
                                        fontWeight: 'bold'
                                    }
                                }
                            },
                            labelLine: {
                                normal: {
                                    show: false
                                }
                            },
                            data:[
                                {value:this.index.repairsCount, name:this.$t('l.repair')},
                                {value:100-this.index.repairsCount ,name:this.$t('l.finish')},
                            ]
                        }
                    ]
                };
            },
            index(){
                return this.$store.state.index.data;
            },
            showglr(){
                return this.$store.state.user.user&&this.$store.state.user.user.current_company == 146;
            }
        },
        watch: {
            simType:{
                handler(newVal, oldVal) {
                    if (this.simTypeChar) {
                        if (newVal) {
                            this.drawChart(this.simTypeChar, "sims", newVal);
                        } else {
                            this.drawChart(this.simTypeChar, "sims", oldVal);
                        }
                    }
                },
                deep: true
            },
            option: {
                handler(newVal, oldVal) {
                    if (this.chart) {
                        if (newVal) {
                            this.drawChart(this.chart, "census", newVal);
                        } else {
                            this.drawChart(this.chart, "census", oldVal);
                        }
                    } else {
                        this.drawChart(this.chart, "census", this.option);
                    }
                },
                deep: true
            },
            optionDiagram: {
                handler(newVal, oldVal) {
                    if (this.diagram) {
                        if (newVal) {
                            this.drawChart(this.diagram, "tree-diagram", newVal);
                        } else {
                            this.drawChart(this.diagram, "tree-diagram", oldVal);
                        }
                    } else {
                        this.drawChart(this.newFault, "tree-diagram", this.optionDiagram);
                    }

                }
            },
            optionNewFault: {
                handler(newVal, oldVal) {
                    if (this.newFault) {
                        if (newVal) {
                            this.drawChart(this.newFault, "new-fault-every-week", newVal);
                        } else {
                            this.drawChart(this.newFault, "new-fault-every-week", oldVal);
                        }
                    } else {
                        this.drawChart(this.newFault, "new-fault-every-week", this.optionNewFault);
                    }
                },
                deep: true
            },
            optionNewLift: {
                handler(newVal, oldVal) {
                    if (this.newLift) {
                        if (newVal) {
                            this.drawChart(this.newLift, "new-lift-every-week", newVal);
                        } else {
                            this.drawChart(this.newLift, "new-lift-every-week", oldVal);
                        }
                    } else {
                        this.drawChart(this.newLift, "new-lift-every-week", this.optionNewLift);
                    }
                },
                deep: true
            },
            optionNewMaintain: {
                handler(newVal, oldVal) {
                    if (this.newMaintain) {
                        if (newVal) {
                            this.drawChart(this.newMaintain, "new-maintain", newVal);
                        } else {
                            this.drawChart(this.newMaintain, "new-maintain", oldVal);
                        }
                    } else {
                        this.drawChart(this.newFault, "new-terminal-every-day", this.optionNewMaintain);
                    }
                },
                deep: true
            },
            onlineOption:{
                handler(newVal,oldVal){
                    if (this.onlineChart) {
                        if (newVal){
                            this.drawChart(this.onlineChart,"lift-stat-census",newVal)
                        } else{
                            this.drawChart(this.onlineChart,"lift-stat-census",oldVal)
                        }
                    }else{
                        this.drawChart(this.onlineChart,"lift-stat-census",this.onlineOption)
                    }
                },
                deep:true
            },
            faultOption:{
                handler(newVal,oldVal){
                    if (this.faultChart) {
                        if (newVal){
                            this.drawChart(this.faultChart,"lift-fault-census",newVal)
                        } else{
                            this.drawChart(this.faultChart,"lift-fault-census",oldVal)
                        }
                    }else{
                        this.drawChart(this.faultChart,"lift-fault-census",this.faultOption)
                    }
                },
                deep:true
            },
            maintenanceOption:{
                handler(newval){
                    if (newval){
                        this.drawChart(this.maintenanceChart,"lift-maintain-census",this.maintenanceOption)
                    }
                }
            },
            repairOption:{
                handler(newval){
                    if (newval){
                        this.drawChart(this.repairChart,"lift-repair-census",this.repairOption)
                    }
                }
            },
            index:{
                handler(newVal, oldVal){
                    if (newVal){
                        this.show=false;
                        // this.drawChart(this.simTypeChar, "sims", this.simType); // 设备类型统计
                        this.drawChart(this.newMaintain, "new-maintain", this.optionNewMaintain); // 维保新增
                        this.drawChart(this.diagram, "tree-diagram", this.optionDiagram); // 故障统计
                        this.drawChart(this.chart, "census", this.option); // 终端设备统计
                        this.drawChart(this.newLift, "new-lift-every-week", this.optionNewLift);// 今日新增电梯
                        this.drawChart(this.newFault, "new-fault-every-week", this.optionNewFault); // 今日新增故障
                        this.drawChart(this.onlineChart, "lift-stat-census", this.onlineOption);// 在线
                        this.drawChart(this.faultChart, "lift-fault-census", this.faultOption); // 故障
                        this.drawChart(this.maintenanceChart, "lift-maintain-census", this.maintenanceOption);// 在线
                        this.drawChart(this.repairChart, "lift-repair-census", this.repairOption); // 故障
                    }
                },
                deep:true
            },
            simCount:{
                handler(newVal, oldVal){
                    if (newVal){
                        this.drawChart(this.simTypeChar, "sims", this.simType); // 设备类型统计
                    }
                },
                deep:true
            }
        },
        methods: {
            drawChart(that, census, option) {
                let dom = document.getElementById(census);
                if (dom) {
                    that = echarts.init(dom);
                    that.clear();
                    that.setOption(option)
                    that.resize();
                }
            },
            loadData(){
                this.showLoadingGif = true;
                util.ajax.get("/indexdata").then(res => {
                    this.showLoadingGif = false;
                    if (res&&!res.code) {
                        if (res.data){
                            this.$store.commit('setIndex',res.data);
                        }
                    }
                })
            },
            // 加载故障月统计
            loadAllMonthData(){
                util.ajax.get("/getmonthfault").then(res => {
                    if (res&&!res.code) {
                        if (res.data){
                            let list = [];
                            let date = new Date();
                            let month = date.getMonth() + 1;
                            for (let i = 1; i <= month; i++) {
                                if (res.data.allMonthFaultCount) {
                                    list.push(res.data.allMonthFaultCount["num" + i]);
                                }
                            }
                            res.data.faultMonthData = list
                            this.$store.commit('setIndex',res.data);
                        }
                    }
                })
            },
            // 加载sim卡信息统计
            loadSimData(){
                util.ajax.get("/simcount").then(res => {
                    this.simCount = res.data;
                })
            },
            init(){
                this.show=true;
                setTimeout(()=>{
                    if (this.show) {
                        this.drawChart(this.simTypeChar, "sims", this.simType); // 设备类型统计
                        this.drawChart(this.newMaintain, "new-maintain", this.optionNewMaintain); // 维保新增
                        this.drawChart(this.diagram, "tree-diagram", this.optionDiagram); // 故障统计
                        this.drawChart(this.chart, "census", this.option); // 终端设备统计
                        this.drawChart(this.newLift, "new-lift-every-week", this.optionNewLift);// 今日新增电梯
                        this.drawChart(this.newFault, "new-fault-every-week", this.optionNewFault); // 今日新增故障
                        this.drawChart(this.onlineChart, "lift-stat-census", this.onlineOption);// 在线
                        this.drawChart(this.faultChart, "lift-fault-census", this.faultOption); // 故障
                        this.drawChart(this.maintenanceChart, "lift-maintain-census", this.maintenanceOption);// 在线
                        this.drawChart(this.repairChart, "lift-repair-census", this.repairOption); // 故障
                        this.show=false;
                    }
                },3000)
            }
        },
        created(){
            this.loadData();
            this.loadSimData();
            this.loadAllMonthData();

        },
        mounted(){
            this.init();
        }
    };
</script>

<style lang="less" scoped>
    img {
        width: 100%;
        height: 100%;
    }
    @import "./home.less";
    .home-main {
        height: calc(95% - 8px);
        padding-top: 8px;
    }
    .home-row,.row-col{
        height: 100%;
        &-left{
            height: 50%;
        }
    }
    ::-webkit-scrollbar{
        display: none;
    }
    .row-col-center{
        &-zero {
            height: calc(12% - 8px);
            margin-bottom: 8px;
        }
        &-one{
            margin-bottom: 8px;
        }
        &-two{
            width: 100%;
        }
        &-three{
            width: 100%;
            margin-top: 8px;
            height: calc(58% - 8px);
        }
    }
    #census {
        width: 100%;
        height: 100%;
    }
    #tree-diagram {
        width: 100%;
        height: 350px;
    }

    #new-maintain {
        width: 100%;
        height: 285px;
    }

    * {
        margin: 0;
        padding: 0;
    }

    ul, li {
        list-style: none;
    }

    .box {
        margin: 0;
        padding: 0;
        width: 180px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .box ul {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .box ul li {
        width: 40px;
        height: 40px;
        border: 1px solid #9fa2ad;
        display: inline-block;
        text-align: center;
        border-radius: 5px;
        box-shadow: inset 0 -2px 0 #f1f1f1, 0 1px 0 #f1f1f1, 0 2px 0 #9fa2ad, 0 3px 0 #f1f1f1, 0 4px 0 #9fa2ad;
        background: -webkit-linear-gradient(top, rgba(248, 248, 248, .3) 20%, rgba(168, 173, 190, .5) 50%, rgba(168, 173, 190, .3) 51%, rgba(248, 248, 248, .2) 90%);
        position: relative;
    }

    .box li span:first-child {
        font-size: 30px;
        color: #52555a;
        display: block;
        /*height:130px;*/
        line-height: 40px;
    }

    .box li:before {
        top: 50%;
        height: 1px;
        box-shadow: 0 1px 0 #868995, 0 2px 1px #fff;
    }
    .demo-spin-icon-load{
        animation: ani-demo-spin 1s linear infinite;
    }
    @keyframes ani-demo-spin {
        from { transform: rotate(0deg);}
        50%  { transform: rotate(180deg);}
        to   { transform: rotate(360deg);}
    }
    .demo-spin-col{
        height: 100px;
        position: relative;
        border: 1px solid #eee;
    }
</style>